import axios from "axios";
import { getToken } from "services/user/user.session.service";
import { getEndpoint } from "./endpoint.service";
import i18next from "i18next";
const BASIC_AUTH_INT = "Basic " + process.env.REACT_APP_API_BASIC_AUTH;
const BASIC_AUTH_PRE = "Basic " + process.env.REACT_APP_API_BASIC_AUTH_PRE;
const BASIC_AUTH_PRO = "Basic " + process.env.REACT_APP_API_BASIC_AUTH_PRO;
const BEARER_AUTH = "Bearer ";
configAxios();



function getEnvinmentBasicAuth() {
  return window.location.host.includes("pre") ?
    BASIC_AUTH_PRE : window.location.host.includes("int") || window.location.host.includes("local") ?
      BASIC_AUTH_INT : BASIC_AUTH_PRO
}

/**
 * @description Post axios envolved with the proyect configuration
 * @param api 
 * @param privateApi 
 * @param url 
 * @param data 
 * @returns {Promise}
 */
export async function postAxios(
  api: string,
  privateApi: boolean,
  url: string,
  data: any,
  forcePre?: boolean,
  timeoutMs?: number, 
): Promise<any> {
  return new Promise((resolve, reject) => {
    // Base config desde tu helper
    const baseConfig = getAuthConfig(privateApi, forcePre);

    // Construimos la config final, sólo añadiendo timeout/signal si vienen
    const config: any = {
      ...baseConfig,
      ...(typeof timeoutMs === 'number' ? { timeout: timeoutMs } : {}),

    };

    axios.post(getEndpoint(api, url), data, config)
      .then((response) => {
        if (response.status !== 204) response.data.status = response.status;
        resolve(response.data);
      })
      .catch((error) => {
        // Si hay respuesta HTTP la devolvemos, si no devolvemos el error completo
        if (error && error.response) {
          reject(error.response);
        } else {
          // Ej: timeout (ECONNABORTED), network error o cancelación
          reject(error);
        }
      });
  });
}

/**
 * @description Get axios envolved with the proyect configuration
 * @param api 
 * @param privateApi 
 * @param url 
 * @param data 
 * @returns {Promise}
 */
export async function getAxios(api: string, privateApi: boolean, url: string, removeLoading = false, data?: any, forcePre?: boolean) {
  return new Promise((resolve, reject) => {
    return axios.get(getEndpoint(api, url), getAuthConfig(privateApi, forcePre, removeLoading))
      .then((response) => {
        if (response.status !== 204) response.data.status = response.status;
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  })
}

/**
 * @description Post axios envolved with the proyect configuration
 * @param api 
 * @param privateApi 
 * @param url 
 * @param data 
 * @returns 
 */
export async function putAxios(api: string, privateApi: boolean, url: string, data: any, forcePre?: boolean) {
  return new Promise((resolve, reject) => {
    return axios.put(getEndpoint(api, url), data, getAuthConfig(privateApi, forcePre))
      .then((response) => {
        if (response.status !== 204) response.data.status = response.status;
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

/**
 * @description Delete axios envolved with the proyect configuration
 * @param api 
 * @param privateApi 
 * @param url 
 * @param data 
 * @returns 
 */
export async function deleteAxios(api: string, privateApi: boolean, url: string, forcePre?: boolean, body?: { data: any }) {
  return new Promise((resolve, reject) => {
    const config = getAuthConfig(privateApi, forcePre);
    const options: any = {
      ...config,
      ...body
    }
    return axios.delete(getEndpoint(api, url), options)
      .then((response) => {
        if (response.status !== 204) response.data.status = response.status;
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

/**
 * @description Patch axios envolved with the proyect configuration
 * @param api 
 * @param privateApi 
 * @param url 
 * @param data 
 * @returns 
 */
export async function patchAxios(api: string, privateApi: boolean, url: string, body: any, forcePre?: boolean) {
  return new Promise((resolve, reject) => {
    return axios.patch(getEndpoint(api, url), body, getAuthConfig(privateApi, forcePre))
      .then((response) => {
        if (response.status !== 204) response.data.status = response.status;
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
}

function configAxios() {
  // HEADERS
  axios.defaults.headers.common["Content-Type"] = "application/json";

}

function getAuthConfig(privateApi: boolean, forcePre?: boolean, removeLoading = false) {
  const auth = privateApi ? BEARER_AUTH + getToken() : forcePre ? BASIC_AUTH_PRE : getEnvinmentBasicAuth();
  const config = {
    headers: {
      "Authorization": auth,
      "Accept-Language": languageMapping(i18next.language)
    },
    validateStatus: function (status: any) {
      return status >= 200 && status < 300; // default
    },
    removeLoading: removeLoading
  }
  return config;
}

function languageMapping(language: string) {
  let result = "";
  switch (language) {
    case 'en':
      //result = 'en-GB,en;q=0.9';
      result = "en"
      break;
    case 'fr':
      //result = 'fr-FR,fr;q=0.9';
      result = "fr"
      break;
    case 'es':
      //result = 'es-ES,es;q=0.9';
      result = "es"
      break;
    case 'gl': // Gallego
      //result = 'gl-ES,gl;q=0.9';
      result = "gl"
      break;
    case 'eu': // Vasco (Euskera)
      //result = 'eu-ES,eu;q=0.9';
      result = "eu"
      break;
    case 'ca': // Catalán
      //result = 'ca-ES,ca;q=0.9';
      result = "ca"
      break;
    case 'va': // Valenciano (usualmente comparte el mismo código con catalán)
      //result = 'ca-ES,ca;q=0.9'; // Se puede usar 'va-ES' si se distingue.
      result = "va"
      break;
    default:
      //result = 'es-ES,es;q=0.9';
      result = "es"
      break;
  }
  return result;
}